/* global google */
import { PropTypes } from 'react'
import BaseGeosuggest from 'react-geosuggest'

import './Geosuggest.scss'

class Geosuggest extends BaseGeosuggest {
  componentDidMount () {
    super.componentDidMount && super.componentDidMount()
    const suggest = {}
    suggest.placeId = this.props.initialLocation.placeId
    suggest.label = this.props.initialLocation.label
    if (suggest.placeId || suggest.label) this.selectSuggest(suggest)
  }
}

Geosuggest.displayName = 'Geosuggest'
Geosuggest.propTypes = {
  ...BaseGeosuggest.propTypes,
  initialLocation: PropTypes.shape({
    placeId: PropTypes.string,
    label: PropTypes.string
  })
}
Geosuggest.defaultProps = {
  ...BaseGeosuggest.defaultProps,
  initialLocation: {
    placeId: '',
    label: ''
  },
  country: 'mx',
  location: new google.maps.LatLng(19.433985, -99.133065),
  radius: 35000
}

export default Geosuggest



// WEBPACK FOOTER //
// ./src/screens/App/shared/components/Geosuggest/Geosuggest.js